export enum RangeType {
  FromToValue = 0,
  FromNegativeInfinite = 1,
  ToPositiveInfinite = 2,
}